import { ModalFooter, ModalBody } from "@chakra-ui/react";
import Modal from "./Modal";
import ModalTheme from "./theme";
import { IllustrationHeaderVariant } from "./Modal.types";
export { Modal, ModalFooter, ModalBody, ModalTheme, IllustrationHeaderVariant, };
//# sourceMappingURL=index.js.map